import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    ListGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { actions } from '../../../../context';
import ClientPluginListItem from '../Controls/ClientPluginListItem';

const listHeight = '500px';

const PluginClientManifestModal = ({
    toggle,
    refreshManifest,
    isOpen = false,
}) => {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('');
    const [plugins, setPlugins] = useState([]);

    const pluginNotes = useSelector((state) => state.clientPlugins.pluginNotes);

    const close = useCallback(() => {
        setFilter('');
        toggle();
    }, [toggle]);

    const refreshPlugins = useCallback(
        () =>
            dispatch(actions.missionControl.getActivePlugins()).then((res) =>
                setPlugins(res || [])
            ),
        [dispatch]
    );

    const getFilteredPlugin = () =>
        plugins.filter((x) =>
            x.name.toLowerCase().includes(filter.toLowerCase())
        );

    const filteredPlugins = () => {
        if (filter === '') return plugins;
        if (plugins.length <= 0) return [];
        return getFilteredPlugin();
    };

    useEffect(() => {
        if (isOpen) refreshPlugins();
        // eslint-disable-next-line
    }, [dispatch, isOpen]);

    return (
        <Modal
            className="text-light"
            style={{ minWidth: '65vw' }}
            centered
            isOpen={isOpen}
            toggle={close}>
            <ModalHeader>Add Plugins</ModalHeader>
            <ModalBody>
                <div className="text-center mb-4">
                    <input
                        type="search"
                        placeholder="Filter Plugins"
                        className="rounded p-1 w-75 text-center"
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <ListGroup
                    style={{
                        minHeight: listHeight,
                        maxHeight: listHeight,
                        overflowY: 'auto',
                    }}>
                    {filteredPlugins().map((p) => (
                        <ClientPluginListItem
                            key={p.id}
                            pluginId={p.id}
                            pluginName={p.name}
                            defaultVersion={p?.defaultVersion?.id}
                            notes={pluginNotes.filter(
                                (n) => n.pluginId === p.id
                            )}
                            refreshManifest={() => refreshManifest()}
                            toggle={close}
                        />
                    ))}
                </ListGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={close}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default React.memo(PluginClientManifestModal);
